import { render, staticRenderFns } from "./InvestorsForStartupList.vue?vue&type=template&id=32d83e1b&scoped=true&"
import script from "./InvestorsForStartupList.vue?vue&type=script&lang=js&"
export * from "./InvestorsForStartupList.vue?vue&type=script&lang=js&"
import style0 from "./InvestorsForStartupList.vue?vue&type=style&index=0&id=32d83e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d83e1b",
  null
  
)

export default component.exports